//import { toDate } from '@a2system/angular/common/helpers/utils';
import { Injectable, OnDestroy, Optional } from '@angular/core';
import { Auth, authState, idToken, getAuth, user,  reauthenticateWithCredential, onIdTokenChanged, onAuthStateChanged, signOut, User, GoogleAuthProvider, sendPasswordResetEmail, authInstance$, reload, getIdTokenResult} from '@angular/fire/auth';
import { doc, docData, onSnapshot, Firestore, docSnapshots, snapToData, fromRef, auditTrail } from '@angular/fire/firestore';
import { isEqual, pick } from 'lodash';
import { NgxRolesService } from 'ngx-permissions';
import { UserDbService } from 'projects/lib/src/datastore/user-db.service';
import { AuthModel } from 'projects/lib/src/models/auth.model';
import { UserModel } from 'projects/lib/src/models/user.model';
import { BehaviorSubject, NEVER, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, distinctUntilKeyChanged, filter, map, skip, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly _user = new BehaviorSubject<any>(null);
  public user$ = this._user.asObservable();
  roles: Array<UserModel.Role> = [];
  // roles: Array<UserModel.Role> = UserModel.roles();
  refreshTokenSubscription: Subscription;
  private isInit = 0;
  constructor(
    @Optional() private auth: Auth,
    @Optional() private firestore: Firestore,
    private userDbService: UserDbService,
    private rolesService: NgxRolesService,
    private router : Router,
    private route : ActivatedRoute

  ) {
    this.init();
  }

  init(){
    console.log("//////////// INICIO AUTH INIT //////////////")
    idToken(this.auth).pipe(distinctUntilChanged()).subscribe(async idToken=>{
      if(idToken){
        const tokenResult = await this.auth.currentUser.getIdTokenResult();
        //TODO tomar los datos del claim y asi no tener que refrescar el usuario
        // console.log("tokenResult.claims", tokenResult.claims)
        const roles = (tokenResult.claims?.roles ?? []) as Array<UserModel.Role>;
        const isDiferent  = !isEqual(roles,  this.roles);
        this.roles = [...roles];
        console.log("roles", this.roles)
        if (isDiferent){
          this.setRoles({roles, user:this.auth.currentUser});
          console.log("isInit", this.isInit);
          if (this.isInit > 1) { //TODO manejar mejor el set de inicio con observables
            // window.location.reload();
          }
        }
        this.isInit += 1;
      }
    })

    // Otro aproach con solo customClaims y podemos obtener los datos solo de ahi (creo que es lo mejor, inclusive para SSR)
    // customClaims(user(this.auth) as any).subscribe(res=>{
    //   console.log("res---------->", res);
    // })

    authState(this.auth).pipe(distinctUntilChanged()).subscribe( (user:User) =>  {
      this._user.next(user);
      if (!user){
        // this.router.navigate(['signin']);
      } else{
        this.isInit += 1;
      }
    })

    this.refreshTokenSubscription = this.tokenChanged$.pipe(skip(1)).subscribe(async t=>{
      if (this.auth.currentUser){
        await this.auth.currentUser.reload(); //TODO se debería eliminar y tomar datos del token
        await this.auth.currentUser.getIdTokenResult(true);
      }
    })
  }

  tokenChanged$ = authState(this.auth).pipe(
    filter(user=> !!user?.uid),
    distinctUntilKeyChanged('uid'),
    switchMap(user=>{
      return user && user.uid
        ? fromRef(doc(this.firestore, `users/${user.uid}/meta/refreshToken`)).pipe(map(snap=>snap.data()))
        : NEVER
    })
  )

  setRoles(authProp: { roles: Array<UserModel.Role>; user: User | null;  company?: string}){
    if (authProp.roles){
      this.roles = authProp.roles
      const roles = {
        'admin':['canAdmin'],
        'installer':['canServices', 'canWindows']
      } as any;
      const perm = authProp.roles.reduce((res, role)=>[...res, ...roles[role]],[]);
      console.log("perm", perm)
      console.log("roles", authProp.roles)
      // console.log("PERMISIOSN", perm)
      //TODO probar mas bien si debemos agragr  this.rolesService.addRoleWithPermissions( 'ADMIN', perm ); por cada rol, en vez de colocar lo qu epuede hacer en uno solo
      //-> POR Lo visto se debe hacer  un flush y agregamos uno por cada role
      this.rolesService.flushRolesAndPermissions();
      this.rolesService.addRoleWithPermissions( 'USERADMIN', perm );
    }
  }

  doLogout() {
    // if (this.refreshTokenSubscription){this.refreshTokenSubscription.unsubscribe()};
    this._user.next(null);
    return this.auth
      ? signOut(this.auth)
      : false
  }

  doSignin(authResult: any):Promise<any>{
    const isNewUser = authResult.additionalUserInfo?.isNewUser;
    let ret = Promise.resolve(true);
    if (isNewUser){
      const providerId = authResult.additionalUserInfo?.providerId ?? 'default' as any;
      const userInfo = authResult.additionalUserInfo;
      const operationType = authResult.operationType; //signIn
      const fireUser = pick(authResult.user, ['displayName', 'email', 'emailVerified', 'isAnonymous', 'pohoneNumber', 'photoURL', 'uid']) as Partial<UserModel>;
      const providerUser = AuthModel.getProviderUser( userInfo?.profile, providerId) as Partial<UserModel>; ;
      const user = UserModel.create({...fireUser, ...providerUser});
      user.id = user.uid;
      user.providerId = providerId;
      ret =  this.userDbService.set(user)
    }
    return ret;
  }

  resetPasswordInit(email: string) {
    return sendPasswordResetEmail(this.auth, email);
  }

  refreshToken(){
    const currentUser = this.auth.currentUser;
    if (currentUser) return  currentUser.getIdToken(true);
    return null;
  }

  reauthenticate(){
    const auth = getAuth();
    const user = auth.currentUser;

    // TODO(you): prompt the user to re-provide their sign-in credentials
    // const credential = promptForCredentials();

    // reauthenticateWithCredential(user, credential).then(() => {
    //   // User re-authenticated.
    // }).catch((error) => {
    //   // An error ocurred
    //   // ...
    // });
  }
}
